import type {
  ClubMembershipRole,
  MembershipRole,
  OutfitterMembershipRole,
} from './seat'
import type { CreateOrgType } from './persona'

const CLUB_ROLE_LABELS: Record<ClubMembershipRole, string> = {
  manager: 'Manager',
  member: 'Member',
  guest: 'Guest',
  contact: 'Contact',
}

const OUTFITTER_ROLE_LABELS: Record<OutfitterMembershipRole, string> = {
  guide: 'Guide',
  outfitter: 'Manager',
  member: 'Member',
  client: 'Customer',
  guest: 'Guest',
  contact: 'Contact',
}

export function roleLabel(role: MembershipRole, orgType: CreateOrgType): string {
  if (orgType === 'outfitter') {
    return OUTFITTER_ROLE_LABELS[role as OutfitterMembershipRole] ?? 'Member'
  }
  return CLUB_ROLE_LABELS[role as ClubMembershipRole] ?? 'Member'
}

export function roleLabelPlural(role: MembershipRole, orgType: CreateOrgType): string {
  return `${roleLabel(role, orgType)}s`
}

const CLUB_ROSTER_ROLES: readonly MembershipRole[] = [
  'manager',
  'member',
  'guest',
  'contact',
]

const OUTFITTER_ROSTER_ROLES: readonly MembershipRole[] = [
  'outfitter',
  'member',
  'guide',
  'guest',
  'contact',
]

export function rosterAssignableRoles(
  orgType: 'club' | 'outfitter',
): readonly MembershipRole[] {
  return orgType === 'outfitter' ? OUTFITTER_ROSTER_ROLES : CLUB_ROSTER_ROLES
}

const CLUB_INVITABLE_ROLES: readonly MembershipRole[] = [
  'member',
  'manager',
  'guest',
]

const OUTFITTER_INVITABLE_ROLES: readonly MembershipRole[] = [
  'member',
  'guide',
  'outfitter',
  'guest',
]

export function invitableRoles(
  orgType: 'club' | 'outfitter',
): readonly MembershipRole[] {
  return orgType === 'outfitter' ? OUTFITTER_INVITABLE_ROLES : CLUB_INVITABLE_ROLES
}

export function rosterRoleValueFromLabel(
  label: string,
  orgType: 'club' | 'outfitter',
): MembershipRole | null {
  const normalized = label.trim().toLowerCase()
  if (normalized === '') return null
  for (const role of rosterAssignableRoles(orgType)) {
    if (roleLabel(role, orgType).toLowerCase() === normalized) return role
  }
  return null
}
